import { createSlice } from "@reduxjs/toolkit";
import { addTemplate, deleteTemplate, getTemplates, toggleTemplateStatus, updateTemplate } from "../../api/template/template";

// giá trị khởi tạo của state
const initialState = {
  templates: [],
  isLoading: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const templateSlice = createSlice({
  name: "template", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplates.pending, (state) => {
        // api đnag pending chờ xử lý
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTemplates.fulfilled, (state, action) => {
        // api trả về thành công thì trả ra
        state.isLoading = false;
        state.templates = action.payload.data || [];
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getTemplates.rejected, (state, action) => {
        // api trả về thất bại thì trả ra
        state.isLoading = false;
        state.error = action.payload;
      });

    // Add Template
    builder.addCase(addTemplate.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(addTemplate.fulfilled, (state, action) => {
      state.isLoading = false;
      // We don't need to update the templates array here as we'll refetch after add
    });
    builder.addCase(addTemplate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể thêm template";
    });

    // Update Template
    builder.addCase(updateTemplate.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(updateTemplate.fulfilled, (state, action) => {
      state.isLoading = false;
      // We don't need to update the templates array here as we'll refetch after update
    });
    builder.addCase(updateTemplate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể cập nhật template";
    });

    // Delete Template
    builder.addCase(deleteTemplate.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(deleteTemplate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.templates = state.templates.filter(
        (template) => template.id !== action.payload.id
      );
      // Total count will be updated on next fetch
    });
    builder.addCase(deleteTemplate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể xóa template";
    });

    // Toggle Template Status
    builder.addCase(toggleTemplateStatus.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(toggleTemplateStatus.fulfilled, (state, action) => {
      state.isLoading = false;
      // We'll refetch the updated list after toggling status
    });
    builder.addCase(toggleTemplateStatus.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể cập nhật trạng thái template";
    });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  templateSlice.actions;
export default templateSlice.reducer;
